export const PRIVACY_AGREEMENT_VERSION = "2026-02-24";
export const PRIVACY_AGREEMENT_LAST_UPDATED_AT = "2026-02-24T00:00:00.000Z";

export const PRIVACY_AGREEMENT_TLDR = [
  "All content produced in this platform is proprietary to ElevationEMS.",
  "Content may only be used by the institution for which it was created.",
  "Do not share, distribute, sell, copy, or monetize platform outputs.",
  "Do not export content outside authorized institutional workflows.",
  "ElevationEMS does not share your data with anyone for any reason."
];

export const PRIVACY_AGREEMENT_FULL_TEXT = [
  "ElevationEMS Platform Proprietary Content and Data Privacy Agreement",
  "",
  "By accepting this agreement, you acknowledge and agree to the following:",
  "",
  "1) Proprietary ownership",
  "All scenarios, simulations, evaluations, question sets, reports, documents, generated outputs, and derivative content created or delivered through the ElevationEMS platform are proprietary intellectual property of ElevationEMS.",
  "",
  "2) Authorized use",
  "You may use platform content only for the authorized educational and operational purposes of the institution for which it was created.",
  "",
  "3) Prohibited use",
  "You may not share, distribute, publish, copy, sell, license, monetize, scrape, or otherwise commercialize platform content or outputs outside authorized institutional use.",
  "",
  "4) No external redistribution",
  "Content and outputs may not be transferred to external organizations, repositories, or individuals unless expressly authorized in writing by ElevationEMS.",
  "",
  "5) Data privacy",
  "ElevationEMS does not share your data with anyone for any reason.",
  "",
  "6) Continuing obligation",
  "These restrictions survive account changes, role changes, and termination of access.",
  "",
  "7) Enforcement",
  "Violation may result in immediate suspension or termination of access and additional legal remedies."
].join("\n");

export const GLOBAL_COPYRIGHT_NOTICE =
  "Copyright © ElevationEMS. All rights reserved. Platform outputs are proprietary and for authorized institutional use only. Redistribution, copying, sale, or external sharing is prohibited.";
